<script setup lang="ts">
import { useBackgroundAudioPlayerStore } from '@/shared/components/players/BackgroundAudioPlayer/store.ts';
import { useAudioPlayer } from '@/shared/components/players/useAudioPlayer.ts';
import { MaybeNull } from '@/shared/types';
import {
  onMounted, Ref, ref,
} from 'vue';

const { setPlayer } = useBackgroundAudioPlayerStore();

const audioPlayer$: Ref<MaybeNull<HTMLAudioElement>> = ref(null);

const player = useAudioPlayer(audioPlayer$);

onMounted(() => {
  setPlayer(player);

  player.setVolume(0);
});
</script>

<template>
  <audio
    id="backgroundAudioPlayer"
    ref="audioPlayer$"
    loop
  />
</template>

<style scoped>

</style>
